customElements.get("parallax-media-grid") || customElements.define("parallax-media-grid", class extends HTMLElement {
  constructor() {
      super(), this.images = this.querySelectorAll(".parallax-media-grid__img")
  }
  connectedCallback() {
      this.init()
  }
  decorateImages() {
      this.querySelectorAll(".parallax-media-grid__gallery__item").forEach((item, index) => {
          item.querySelector(".parallax-media-grid__img").classList.add(`parallax-media-grid__img--${index%2===0?"odd":"even"}`)
      })
  }
  rotateOnScroll() {
      const {
          images
      } = this, maxRotation = parseInt(this.dataset.rotation, 10) || 5;
      document.addEventListener("scroll", function() {
          images.forEach(image => {
              const imageRect = image.getBoundingClientRect(),
                  windowHeight = window.innerHeight;
              if (imageRect.top < windowHeight) {
                  let visiblePercent = (windowHeight - imageRect.top) / windowHeight * 100,
                      rotationDegree = Math.min(visiblePercent / 100 * maxRotation, maxRotation);
                  image.classList.contains("parallax-media-grid__img--odd") && (rotationDegree *= -1), window.requestAnimationFrame(() => {
                      image.style.transform = `translate3d(0px, 0px, 0px) rotate(${rotationDegree}deg)`
                  })
              }
          })
      })
  }
  init() {
      this.decorateImages(), this.rotateOnScroll()
  }
});